import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const NavBar = () => {
	const [authCookie, setAuthCookie] = useState("")
	useEffect(() => {
		const cookie = Cookies.get("resilire_auth")
		if (cookie) {
			setAuthCookie(cookie)
		}
	}, [authCookie])
	const decodedAuth = atob(authCookie)
	if (decodedAuth ==='admin') {
	return (
			<nav>
				<h1>Resilire Time Clock</h1>
				<ul>
					<li>
						<NavLink to="/">Clock In/Out</NavLink>
					</li>
					<li>
						<NavLink to="/admin">Admin</NavLink>
					</li>
					<li>
						<NavLink to="/logout">Log out</NavLink>
					</li>
				</ul>
			</nav>
		);
	} else {
		return (
			<nav>
				<h1>Resilire Time Clock</h1>
				<ul>
					<li>
						<NavLink to="/">Clock In/Out</NavLink>
					</li>
					<li>
						<NavLink to="/logout">Log out</NavLink>
					</li>
				</ul>
			</nav>
		);
	}
};

export default NavBar;
